<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center"><br/><br/></p>
<p class="center"><a href="#/OEBPS/toc.htm#also"><strong>Also by Yan Lianke</strong></a></p>
<p class="center1"><em>The Four Books</em></p>
<p class="center1"><em>Lenin’s Kisses</em></p>
<p class="center1"><em>Dream of Ding Village</em></p>
<p class="center1"><em>Serve the People!</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also.vue?418cd663